import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_CALENDARDATAS = "calendardatas";
const BASE_URL = "/api/calendardatas";

const CalendarDatasQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const CALENDARDATAS_EMPTY = {
    title:"",
    description:"",
    type:"Vergadering",
    location:"",
    date:""
};

export function useCalendarDatas() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CALENDARDATAS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...CalendarDatasQueryConfig
    });
    return {...result, calendardatas: result.data};
}


export function useCalendarData(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CALENDARDATAS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...CalendarDatasQueryConfig
    });
    return {...result, dmodel: result.data};
}

export function useCalendarDataMutations() {
    async function createFunction(dmodel) {
        if (!dmodel) return;
        return await fetchPOST(BASE_URL, dmodel, false);
    }

    async function editFunction(dmodel) {
        if (!dmodel) return;
        return await fetchPUT(`${BASE_URL}/${dmodel.id}`, dmodel);
    }

    async function editAddNewFiles(dmodel) {
        if (!dmodel) return;
        return await fetchPUT(`${BASE_URL}/${dmodel.id}/files`, dmodel.fileId);
    }

    async function deleteFunction(dmodel) {
        return await fetchDELETE(`${BASE_URL}/${dmodel.id}`)
    }

    return {
        createCalendarData: useMyMutation(createFunction, REACT_QUERY_ID_CALENDARDATAS, dmodel => `CalendarData ${dmodel.title} created`),
        editCalendarData: useMyMutation(editFunction, REACT_QUERY_ID_CALENDARDATAS, dmodel => `CalendarData ${dmodel.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_CALENDARDATAS, dmodel => `CalendarData ${dmodel.title} modified`),
        deleteCalendarData: useMyMutation(deleteFunction, REACT_QUERY_ID_CALENDARDATAS, dmodel => `CalendarData ${dmodel.title} deleted.`)
    };

}